import React from 'react'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './moeder.css'

const Moeder = (props) => {
  return (
    <div className="moeder-container1">
      <Helmet>
        <title>Moeder - marjangerrits.nl</title>
        <meta property="og:title" content="Moeder - marjangerrits.nl" />
      </Helmet>
      <NavbarInteractive rootClassName="navbar-interactiveroot-class-name9"></NavbarInteractive>
      <div className="moeder-container2">
        <div className="moeder-container3">
          <img
            alt="image"
            src="/Blog foto's/moeder%20copy-700w.jpg"
            className="moeder-foto"
          />
          <div className="moeder-container4">
            <span className="moeder-titel">
              <span>Moeder</span>
              <br></br>
            </span>
            <p className="moeder-datum">
              <span>30-10-2022</span>
              <br></br>
            </p>
            <p className="moeder-text14">
              <span className="Schuingedrukt_tekst">
                Mijn moeder is in december 2020 op 100-jarige leeftijd
                overleden. Deze tekst gaat over het laatste jaar van haar
                leven. 
              </span>
              <br></br>
              <br></br>
              <span>
                Ze denken dat ik gek ben, maar dat is niet zo. Elke avond komen
                ze. Ik zie ze toch. Vanuit mijn bed kan ik net door de halfopen
                slaapkamerdeur naar de woonkamer kijken. Precies daar staat de
                grote leunstoel. Die is favoriet. Anderen zitten op de bank. Die
                zie ik niet vanuit mijn slaapkamer. Ik hoor ze wel hoor.
              </span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
            </p>
          </div>
        </div>
        <p className="moeder-text22">
          <span>
            En aan de kreukels kan ik zien dat ze daar ook zitten. De laatste
            week zit er een vrouw in de leunstoel met een kind. Een kind! Ik
            geloof dat het een meisje is. De vrouw heeft een hoofddoekje om. En
            ze blijft de hele nacht. Met het kind op schoot vallen ze in de
            stoel in slaap. Misschien is ze wel een beetje incontinent. Als ik
            ’s morgens de kamer in gereden wordt, zie ik een vochtige plek op de
            stoel. Toch zonde. Ik denk dat ik er maar wat oude kranten op leg.
          </span>
          <br></br>
          <br></br>
          <span>
            Ook gebruiken ze de keuken. Ik kan vanuit mijn bed zien dat er licht
            brandt. En ik hoor gepraat. Ik weet niet wat ze er allemaal doen.
            Mijn dochter doet de boodschappen en zegt dat er niets weg is. Dat
            zegt ze alleen om mij gerust te stellen, natuurlijk verdwijnt er van
            alles. En ik vermoed dat ze ook koekjes eten uit de koektrommel. Hij
            is soms heel snel leeg. Daarom stop ik voor de zekerheid de trommel
            in het kastje naast mijn stoel. En alle belangrijke spullen bewaar
            ik in mijn rollator. Die neem ik overal mee naar toe. ’s Nachts
            staat hij naast mijn bed zodat niemand erbij kan.
          </span>
          <br></br>
          <span>
            Die rare mensen kijken ook tv. Ze zullen wel blij zijn met die grote
            rottelevisie die ik van mijn dochters voor mijn 100e verjaardag heb
            gehad. Dat ding is groter dan de kast waar hij op staat. De
            gordijnen kunnen er nog amper langs. Die oude was goed genoeg voor
            dat poosje dat ik nog leef. Ze hadden beter een bos bloemen kunnen
            geven. Wat moet ik met zo’n groot geval.
          </span>
          <br></br>
          <br></br>
          <span>
            Maar die mensen hè. Elke avond. Ze wachten tot ik naar bed ben en
            dan komen ze. Volgens mij zijn het mensen van boven. En als de deur
            op slot zit, komen ze door het raam. Ik weet niet hoe maar ik hoor
            het wel. En de zoom van het gordijn was ook losgegaan. Als ik het
            aan anderen vertel geloven ze me niet. Maar ik ben niet gek hoor, ik
            weet wat ik zie.
          </span>
          <br></br>
          <span>
            Nu is er een vreemde griep in de wereld. Mijn dochters mogen niet
            meer naar binnen. Maar die mensen blijven wel gewoon komen. Ze
            houden zich niet aan de regels. Ach, vroeger hadden we ook zo vaak
            griep. Gaat vanzelf weer over. Wat een toestand maken ze ervan. Nu
            moet ik elke keer naar buiten omdat iemand me wil zien. Ook als ik
            nog niet eens de krant uit heb.
          </span>
          <br></br>
          <br></br>
          <span>
            De jongste woont helemaal bij de zee, die kan niet zo gemakkelijk
            langskomen. Maar we zien en spreken elkaar wel. Via zo’n modern
            apparaatje. De vrijwilligster komt hem brengen en zet hem aan.  De
            jongste wil alles weten van vroeger. ‘U bent de laatste die die
            verhalen nog vertellen kan’, zegt ze. Dat klopt. Iedereen is dood.
            Mijn man, mijn broers en mijn zusje. Vroeger was alles veel leuker.
            Ik vertel er graag over. Ook over de oorlog. Die verhalen wil ze het
            liefst horen. Ik heb ook zoveel meegemaakt. Een enkele keer hebben
            we het ook over nu. Dan mopper ik omdat het hier in het tehuis
            steeds beroerder wordt. Allemaal andere verzorgers. Je kent geen
            mens meer. Laatst had ik kousen met grote ladders aangekregen. Toen
            ik er iets van zei, zei die vrouw: ‘dat ziet toch niemand.’
          </span>
          <br></br>
          <span>
            Ook vertel ik mijn dochter over de mensen die elke nacht hier
            zitten. Daar gaat ze nooit op in. Ze gelooft het natuurlijk ook
            niet. Niemand gelooft me. Maar het is wel waar, ik zie het immers
            zelf. 
          </span>
          <br></br>
          <br></br>
          <span>
            Vandaag hebben we weer een nieuwsbrief gekregen, de zoveelste. Ik
            heb hem wel gelezen maar weet niet meer wat erin staat. Zal wel weer
            over die griep gaan. De brief past bijna niet meer in mijn rollator.
            Wat een rommel. Ik moet hem nodig opruimen. Die nieuwsbrieven kunnen
            wel bij het oud papier. Wat zit er nou onder? Verdikkeme, een stuk
            touw. Oh, er zit een hartje aan. Van zeep. Met kruiden erin en het
            ruikt best lekker. Hoe kom ik daar ook alweer aan? Dat weet ik niet
            meer hoor. Ik kan niet alles onthouden.
          </span>
          <br></br>
          <br></br>
          <span>
            Een paar jaar geleden, mijn man leefde al niet meer, hebben ze
            beneden in de zaal de lange tafel weggehaald. Er staan nu allemaal
            kleine tafels. Je kunt niet overal meer gaan zitten zoals vroeger.
            Ik vind er niets meer aan. Het liefst wil ik weg hier. Kunnen die
            nachtelijke bezoekers de boel inpikken. Heb ik er geen last meer
            van. Ze denken dat ik niet meer weglopen kan. Maar dat kan ik wel
            hoor. Ik ga elke dag nog een keer naar het keukentje. Ik trippel met
            mijn voeten en dan gaat de rolstoel vooruit. Langzaam maar dat maakt
            niet uit. Ik kom er toch. De rollator duw ik dan gewoon mee. Ja, ik
            ga weglopen. Ik ga gewoon in het bos wonen, de Albert Heijn is
            vlakbij.
          </span>
          <br></br>
        </p>
      </div>
      <div className="moeder-andere-blogs">
        <h2 className="moeder-lees-ook">
          <span>Lees ook:</span>
          <br></br>
        </h2>
        <div className="moeder-laatste3-blogposts"></div>
      </div>
      <Footer rootClassName="footerroot-class-name10"></Footer>
    </div>
  )
}

export default Moeder
